export const ROLES = [
  { id: 'redeemer', itemName: 'Redeemer' },
  { id: 'visit:recorder', itemName: 'Visit Recorder' },
  { id: 'visit:view', itemName: 'Visit Viewer' },
  { id: 'coupon:edit', itemName: 'Coupon Editor' },
  { id: 'coupon:admin', itemName: 'Coupon Admin' },
  { id: 'coupon:view', itemName: 'Coupon Reports' },
  { id: 'coupon:tester', itemName: 'Coupon Tester' },
  { id: 'notification:edit', itemName: 'Notification Editor' },
  { id: 'notification:admin', itemName: 'Notification Admin' },
  { id: 'notification:view', itemName: 'Notification Reports' },
  { id: 'notification:tester', itemName: 'Notification Tester' },
  { id: 'signage:view', itemName: 'Signage Viewer' },
  { id: 'signage:admin', itemName: 'Signage Admin' },
  { id: 'reports', itemName: 'Reports'},
  { id: 'token:view', itemName: 'Token View'},
  { id: 'admin', itemName: 'Admin' },
  { id: 'super-admin', itemName: 'Super Admin' },
];

export interface IRole {
  id: string;
  itemName: string;
}
